import { useState } from "react";
import { useEditAdminProfileMutation } from "../../Services/DasboardAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import CryptoJS from "crypto-js";
import { useNavigate} from "react-router-dom";

function RegisterForm() {
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [editProfile, { isLoading }] = useEditAdminProfileMutation();

    const validateForm = () => {
        let newErrors = {};
    
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_\-+=])[A-Za-z\d@$!%*?&#^()_\-+=]{8,}$/;
    
        if (!password.trim()) {
            newErrors.password = "Password is required";
        } else if (!passwordRegex.test(password)) {
            newErrors.password = "Password must be at least 8 characters, include uppercase, lowercase, number, and special character";
        }
    
        if (!confirmPassword.trim()) {
            newErrors.confirmPassword = "Confirm Password is required";
        } else if (confirmPassword !== password) {
            newErrors.confirmPassword = "Passwords do not match";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setErrors((prev) => ({ ...prev, password: "" })); // Clear password error on change
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setErrors((prev) => ({ ...prev, confirmPassword: "" })); // Clear confirm password error on change
    };

    const encryptData = (data) => {
        const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
        const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);
    
        if (!key || !iv) {
          console.error("Encryption key or IV is missing!");
          return null;
        }
    
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
    
        return encrypted.toString();
      };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const EncryptedPassword = encryptData(password);
        const EncryptedConfirmPassword = encryptData(confirmPassword);

        try {
            let formData = {
                password: EncryptedPassword,
                password_confirmation: EncryptedConfirmPassword
            };
            await editProfile(formData).unwrap();
            alert("Password updated successfully!");
            navigate("/login");
        } catch (error) {
            console.error("Error updating password", error);
        }
    };

    return (
        <div>
            <h3>Change Password</h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    {/* Password Field */}
                    <div className="mb-3 position-relative">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Enter password"
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                        {errors.password && <p className="text-danger">{errors.password}</p>}
                    </div>

                    {/* Confirm Password Field */}
                    <div className="mb-3 position-relative">
                        <label className="form-label">Confirm Password</label>
                        <div className="input-group">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                placeholder="Confirm password"
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                        {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword}</p>}
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary">
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default RegisterForm;
